import React, { useState } from "react";

const FaqCardComponent = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  const faqs = [
    {
      question: "Why do I need an interior designer?",
      answer:
        "An interior designer is key to transforming your space into something that reflects your personal style while ensuring functionality. \nAt Grow Home Studio, we guide you from concept to completion, offering expert advice on layout, materials, and design elements. We manage all the details of the design process, including custom furniture creation, so you can enjoy a stress-free experience while creating your dream space.",
    },
    {
      question: "How does the Grow Home Studio interior design process work?",
      answer:
        "Our interior design process is designed to be simple and effective: \n1. Initial Consultation: We start by understanding your vision, needs, and budget. \n2. Design Proposal: We then create a detailed design with layouts, material suggestions, and cost estimates. \n3. Approval & Refinement: Once we present the proposal, you have the chance to provide feedback and make any adjustments. \n4. Execution: We handle everything, from sourcing materials to custom furniture creation, ensuring that your design comes to life. \n5. Final Touches: After installation, we perform a final review to ensure everything is perfect before handover.",
    },
    {
      question: "How much does interior design with Grow Home Studio cost?",
      answer:
        "The cost of interior design services depends on the size of your home, the materials chosen, and the scope of work. Below is an estimated cost breakdown for different types of projects to help you plan your budget: \n 1 BHK - Starting at 3.00L* \n 2 BHK - Starting at 4.00L* \n 3 BHK - Starting at 5.50L* \n 4 BHK - Starting at 6.50L* \n Modular Kitchens - Starting at 1.50L* \nThe prices above include only modular interiors for new homes and are estimates based on average project requirements. Actual costs may vary based on the scope of work, materials, and customisation options. At Grow Home Studio, we specialise in crafting custom designs for bedrooms, living rooms, modular kitchens, kids' rooms, balconies, and more.",
    },
    {
      question:
        "How do I communicate with your team throughout the design process?",
      answer:
        "We make communication easy and transparent. You can stay connected with our team via phone, email, or video calls throughout the project. We also use a collaborative project management platform where you can track the progress, share feedback, and ask questions at any time. Our team is always available to ensure everything is running smoothly and according to your vision.",
    },
    {
      question: "Are our designs customisable?",
      answer:
        "Yes! At Grow Home Studio, we offer fully customisable designs to fit your personal preferences and the unique needs of your space. Whether it's custom furniture, tailored colour schemes, or personalised layout changes, we ensure that every aspect of your home is designed to reflect your style. From modern minimalist to classic elegance, we create interiors that are a true extension of you.",
    },
    {
      question:
        "What is the typical timeline for a Grow Home Studio interior design project?",
      answer:
        "1. Initial Consultation: Discuss your vision, budget, and project scope. \n2. Design Customized for You: Develop concepts, plan the space, and select materials. \n3. Agreement: Sign a contract and confirm the final budget. \n4. Execution: Manage the project, create custom furniture, and maintain communication. \n5. Delivery: Inspect the completed project, handover, and offer aftercare services.",
    },
  ];

  const renderAnswer = (answer) => {
    return answer.split("\n").map((line, index) => (
      <React.Fragment key={index}>
        {line}
        <br />
      </React.Fragment>
    ));
  };

  return (
    <section className="container mx-auto py-16">
      <h2 className="text-2xl font-bold mb-8 text-center">
        Frequently Asked Questions
      </h2>
      <div className="max-w-screen-xl mx-auto px-4">
        <div className="grid grid-cols-12 gap-4">
          <div className="col-span-1"></div>
          <div className="col-span-10">
            <div className="accordion">
              {faqs.map((faq, index) => (
                <div
                  key={index}
                  className={`accordion-item ${
                    index !== faqs.length - 1 && "border-b border-gray-200"
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => toggleAccordion(index)}
                    className="flex items-center justify-between w-full p-4 text-left text-gray-900 rounded-lg hover:bg-gray-100 focus:ring-4 focus:ring-blue-200"
                  >
                    <span className="text-md font-inter text-gray-600 flex-grow">
                      {faq.question}
                    </span>
                    <svg
                      className={`w-6 h-6 transition-transform ${
                        activeIndex === index ? "rotate-180" : ""
                      }`}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{ flexShrink: 0 }}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </button>
                  {activeIndex === index && (
                    <div className="mt-2 pl-4 text-left p-2">
                      <p className="text-gray-500 font-inter text-sm">
                        {renderAnswer(faq.answer)}
                      </p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
          <div className="col-span-1"></div>
        </div>
      </div>
    </section>
  );
};

export default FaqCardComponent;
